<template>
  <v-btn
      :color="buttonColor"
      :dark="!disabled && !outline && !loading"
      :disabled="disabled || loading"
      :outlined="outline"
      :loading="loading"
      @click="$emit('click')">
    <slot>Grab</slot>
  </v-btn>
</template>

<script>
export default {
  name: 'DefaultButton',
  props: {
    color: {
      type: String,
      default: 'green'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonColor() {
      switch (this.color) {
        case 'orange':
          return '#FF9947';
        case 'red':
          return '#D13337';
        case 'blue':
          return '#0081D5';
      }
      return '#03BD5B';
    }
  }
};
</script>

<style scoped>
  .v-btn {
    border-radius: 5px;
    min-width: var(--button-width) !important;
    min-height: var(--button-height) !important;
  }

  .v-btn .v-btn__content {
    font-weight: bold;
  }
</style>
